import Seo, { orgSchema, breadcrumbSchema } from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { FadeUp } from "@/components/Reveal";
import { SITE } from "@/data/content";

const SECTIONS = [
    {
        title: "Who we are",
        body: `Dagaz Development is an Oregon-based design-and-build development company delivering projects across the United States and Canada. This policy explains what we collect on this website and how we use it.`,
    },
    {
        title: "What we collect",
        body: `When you use the contact form or the project brief form, we collect the details you provide: name, email address, phone number (optional), project details and your consent to be contacted. We do not store form submissions in a database on this site; they are delivered to us by email.`,
    },
    {
        title: "How we use it",
        body: `We use your details only to respond to your enquiry, prepare a proposal if you ask for one, and keep a record of our correspondence. We do not sell, rent or share your details with third parties for marketing.`,
    },
    {
        title: "Analytics & cookies",
        body: `This site may use privacy-conscious analytics to understand which pages are read and improve the content. No advertising trackers are used. You can block cookies in your browser without losing access to any content.`,
    },
    {
        title: "Your rights",
        body: `You may ask at any time what we hold about you, request a copy, or ask us to delete it. Email ${SITE.email} and we will respond within ten business days.`,
    },
    {
        title: "Changes",
        body: `If this policy changes, the date below is updated and significant changes are noted on this page. Last updated: July 2026.`,
    },
];

export default function Privacy() {
    return (
        <>
            <Seo
                title="Privacy Policy | Dagaz Development"
                description="How Dagaz Development collects, uses and protects your information — short version: only what you send us, only to answer you."
                path="/privacy"
                jsonLd={[orgSchema, breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Privacy", path: "/privacy" }])]}
            />
            <PageHeader
                eyebrow="Legal — Privacy"
                titleLines={["Privacy, in", "plain language."]}
                crumbs={[{ name: "Privacy" }]}
            />
            <section className="px-6 md:px-12 lg:px-16 pb-28 md:pb-40 bg-chalk" data-testid="privacy-body">
                <div className="max-w-3xl space-y-14">
                    {SECTIONS.map((s, i) => (
                        <FadeUp key={s.title} delay={0.05 * i}>
                            <div className="grid md:grid-cols-12 gap-6 border-t border-graphite/15 pt-8">
                                <p className="md:col-span-3 font-sans text-[10px] font-medium tracking-[0.28em] uppercase text-slate">
                                    {String(i + 1).padStart(2, "0")}
                                </p>
                                <div className="md:col-span-9">
                                    <h2 className="font-serif font-light text-2xl md:text-3xl text-graphite">{s.title}</h2>
                                    <p className="mt-4 font-sans text-base leading-relaxed text-graphite/75">{s.body}</p>
                                </div>
                            </div>
                        </FadeUp>
                    ))}
                    <FadeUp className="border-t border-graphite/15 pt-8">
                        <p className="font-sans text-sm text-slate">
                            Questions about privacy: <a href={`mailto:${SITE.email}`} data-testid="privacy-email" className="text-graphite link-rule">{SITE.email}</a>
                        </p>
                    </FadeUp>
                </div>
            </section>
        </>
    );
}
